import projection from '../generated/pwj228f1.json';
import { AcceptanceManifest } from '../types';

export const pwj228f1AcceptanceManifest = projection as AcceptanceManifest;
